<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	width="100%"
	height="100%"
	viewBox="0 0 823 942"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={classes('', additionalClass)}
>
	<g style="mix-blend-mode:multiply" filter="url(#filter0_f_8334_16832)">
		<path
			d="M819.906 414.738C772.161 236.552 602.634 127.158 441.257 170.399C279.879 213.64 121.428 308.466 169.107 576.65C216.851 754.836 378.084 878.921 533.535 677.669C661.398 512.133 867.65 592.923 819.906 414.738Z"
			fill="url(#paint0_linear_8334_16832)"
		/>
	</g>
	<defs>
		<filter
			id="filter0_f_8334_16832"
			x="0.490234"
			y="0.958008"
			width="986.451"
			height="940.242"
			filterUnits="userSpaceOnUse"
			color-interpolation-filters="sRGB"
		>
			<feFlood flood-opacity="0" result="BackgroundImageFix" />
			<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
			<feGaussianBlur stdDeviation="80" result="effect1_foregroundBlur_8334_16832" />
		</filter>
		<linearGradient
			id="paint0_linear_8334_16832"
			x1="207.181"
			y1="633.19"
			x2="814.424"
			y2="363.686"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#F7FBA5" />
			<stop offset="0.541667" stop-color="#D09CC7" />
			<stop offset="1" stop-color="#8F00FF" />
		</linearGradient>
	</defs>
</svg>
